import { render, staticRenderFns } from "./SuppliesTableBody.vue?vue&type=template&id=de108814&scoped=true&"
import script from "./SuppliesTableBody.vue?vue&type=script&lang=ts&"
export * from "./SuppliesTableBody.vue?vue&type=script&lang=ts&"
import style0 from "./SuppliesTableBody.vue?vue&type=style&index=0&id=de108814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de108814",
  null
  
)

export default component.exports